// src/routes/SuperAdminRoutes.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import SuperAdminLayout from '../components/layout/SuperAdminLayout'; // El marco
import ModuloGuard from '../components/ModuloGuard';
//Contenido
import SuperAdminDashboard from '../pages/SuperAdminDashboard';
import Configuraciones from '../pages/Configuraciones';
import ConfiguracionRecibos from '../pages/ConfiguracionRecibos';
import PreguntasFrecuentes from '../pages/PreguntasFrecuentes';
import Soporte from '../pages/Soporte';
import Perfil from '../pages/Perfil';
import HorariosAmenidades from '../pages/HorariosAmenidades';
import MudanzaConfig from '../pages/MudanzaConfig';
import Comunidad from '../pages/Comunidad';
import DatosContactoProveedores from '../pages/DatosContactoProveedores';
import ChatComunitario from '../pages/ChatComunitario';
import ValidacionDocumentos from '../pages/ValidacionDocumentos';
import Amenidades from '../pages/Amenidades';
import Vigilancia from '../pages/Vigilancia';
import Finanzas from '../pages/Finanzas';
import ListaEgresos from '../pages/ListaEgresos';
import ListaIngresos from '../pages/ListaIngresos';
import MetricasBolsasFinancieras from '../pages/MetricasBolsasFinancieras';
import RecibosEliminados from '../pages/RecibosEliminados';
import Administracion from '../pages/Administracion';
import DepartamentosResidentes from '../pages/DepartamentosResidentes';
import ResidentStatusPage from '../pages/ResidentStatusPage';
import ReporteMorosidadConfigurable from '../pages/ReporteMorosidadConfigurable';
import DepartamentosIdentificacion from '../pages/DepartamentosIdentificacion';
import DepartamentosMudanzas from '../pages/DepartamentosMudanzas';
import DepartamentosRFID from '../pages/DepartamentosRFID';
import Propietarios from '../pages/Propietarios';
import Arrendados from '../pages/Arrendados';
import GestionarCuentasVigilancia from '../pages/GestionarCuentasVigilancia';
import CobroSanciones from '../pages/CobroSanciones';
import ActivarConvenios from '../pages/ActivarConvenios';
import ConstanciaNoAdeudo from '../pages/ConstanciaNoAdeudo';
import GenerarReciboCobro from '../pages/GenerarReciboCobro';
import CuotasExtraordinarias from '../pages/CuotasExtraordinarias';
import ConsumoAguaPotable from '../pages/ConsumoAguaPotable';

import ImportarDatos from '../pages/ImportarDatos';
import ImportarHistorico from '../pages/ImportarHistorico';
import GestionSaldos from '../pages/Configuraciones/GestionSaldos';
import ConfiguracionFinanciera from '../pages/ConfiguracionFinanciera';
import AvisosPage from '../pages/AvisosPage';
import CrearComunicado from '../components/CrearComunicado';
import GenerarTicket from '../pages/GenerarTicket';
import CrearCasa from '../pages/CrearCasa';
import ListaComunicados from '../pages/ListaComunicados';
import VotacionesPage from '../pages/VotacionesPage';
import CrearVotacion from '../pages/CrearVotacion';
import PropuestasIncidencias from '../pages/PropuestasIncidencias';
import CrearReporteComunidad from '../pages/CrearReporteComunidad';
import EventosCitas from '../pages/EventosCitas';
import MiDocumentacion from '../pages/MiDocumentacion';
import AvisoPrivacidad from '../pages/AvisoPrivacidad';
import DesktopOnlySectionGuard from '../components/DesktopOnlySectionGuard';
import FacturacionPresupuestosPage from '../pages/FacturacionPresupuestos/FacturacionPresupuestosPage';

const SuperAdminRoutes = () => {
    const isMobile = window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    return (
        <Routes>
            <Route element={<SuperAdminLayout />}>
                <Route index element={<Navigate to={isMobile ? "vigilancia" : "dashboard"} replace />} />
                <Route path="dashboard" element={
                    isMobile ? (
                        <DesktopOnlySectionGuard tituloSeccion="Panel General Analítico">
                            <SuperAdminDashboard />
                        </DesktopOnlySectionGuard>
                    ) : <SuperAdminDashboard />
                } />

                <Route path="configuraciones" element={<Configuraciones />} />
                <Route path="configuraciones/faq" element={<PreguntasFrecuentes />} />
                <Route path="configuraciones/soporte" element={<Soporte />} />
                <Route path="configuraciones/perfil" element={<Perfil />} />
                <Route path="configuraciones/recibos" element={
                    <DesktopOnlySectionGuard tituloSeccion="Configuración de Recibos">
                        <ConfiguracionRecibos />
                    </DesktopOnlySectionGuard>
                } />
                <Route path="configuraciones/importar" element={
                    <DesktopOnlySectionGuard tituloSeccion="Carga Masiva de Datos">
                        <ImportarDatos />
                    </DesktopOnlySectionGuard>
                } />
                <Route path="configuraciones/importar-historico" element={
                    <DesktopOnlySectionGuard tituloSeccion="Importación de Históricos">
                        <ImportarHistorico />
                    </DesktopOnlySectionGuard>
                } />
                <Route path="configuraciones/saldos" element={
                    <DesktopOnlySectionGuard tituloSeccion="Gestión de Saldos Contables">
                        <GestionSaldos />
                    </DesktopOnlySectionGuard>
                } />
                <Route path="configuraciones/financiera" element={
                    <DesktopOnlySectionGuard tituloSeccion="Configuración Financiera">
                        <ConfiguracionFinanciera />
                    </DesktopOnlySectionGuard>
                } />
                <Route path="configuraciones/mudanzas" element={<MudanzaConfig />} />
                <Route path="configuraciones/amenidades-horarios" element={<HorariosAmenidades />} />

            <Route path="comunidad" element={<Comunidad />} />

            <Route path="comunidad/avisos" element={<AvisosPage />} />
            <Route path="comunidad/propuestas" element={<PropuestasIncidencias />} />
            <Route path="comunidad/propuestas/nueva" element={<CrearReporteComunidad />} />
            <Route path="comunidad/eventos" element={<EventosCitas />} />
            <Route path="comunidad/eventos/agendar" element={<EventosCitas />} />

            <Route path="comunidad/chat" element={
                <ModuloGuard moduloKey="chat_comunitario">
                    <ChatComunitario />
                </ModuloGuard>
            } />
            <Route path="comunidad/documentos" element={<ValidacionDocumentos />} />
            <Route path="comunidad/contacto-proveedores" element={<DatosContactoProveedores />} />

            <Route path="comunidad/votaciones" element={<VotacionesPage />} />
            <Route path="comunidad/votaciones/crear" element={<CrearVotacion />} />
            <Route path="comunidad/votaciones/editar/:votacionId" element={<CrearVotacion />} />

            <Route path="comunidad/comunicados/nuevo" element={<CrearComunicado />} />
            <Route path="comunidad/comunicados/editar/:comunicadoId" element={<CrearComunicado />} />
            {/*:se usa para usar las rutas dinámicas */}
            <Route path="comunidad/comunicados/:categoria" element={<ListaComunicados />} />


            <Route path="amenidades" element={
                <ModuloGuard moduloKey="amenidades">
                    <Amenidades />
                </ModuloGuard>
            } />

            <Route path="vigilancia" element={<Vigilancia />} />

            <Route path="finanzas" element={
                <DesktopOnlySectionGuard tituloSeccion="Módulo Financiero y Contable">
                    <Finanzas />
                </DesktopOnlySectionGuard>
            } />
            <Route path="finanzas/egresos" element={
                <DesktopOnlySectionGuard tituloSeccion="Control de Egresos">
                    <ListaEgresos />
                </DesktopOnlySectionGuard>
            } />
            <Route path="finanzas/ingresos" element={
                <DesktopOnlySectionGuard tituloSeccion="Control de Ingresos y Recibos">
                    <ListaIngresos />
                </DesktopOnlySectionGuard>
            } />
            <Route path="finanzas/metricas-bolsas" element={
                <DesktopOnlySectionGuard tituloSeccion="Métricas de Bolsas Financieras">
                    <MetricasBolsasFinancieras />
                </DesktopOnlySectionGuard>
            } />
            <Route path="finanzas/recibos-eliminados" element={
                <DesktopOnlySectionGuard tituloSeccion="Auditoría de Recibos Eliminados">
                    <RecibosEliminados />
                </DesktopOnlySectionGuard>
            } />

            <Route path="administracion" element={
                <ModuloGuard moduloKey="administracion">
                    <Administracion />
                </ModuloGuard>
            } />
            <Route path="administracion/departamentos/residentes" element={<DepartamentosResidentes />} />
            <Route path="administracion/departamentos/residentes/morosos/reporte" element={
                <DesktopOnlySectionGuard tituloSeccion="Reporte Avanzado de Morosidad">
                    <ReporteMorosidadConfigurable />
                </DesktopOnlySectionGuard>
            } />
            <Route path="administracion/departamentos/residentes/:statusType" element={<ResidentStatusPage />} />
            <Route path="administracion/departamentos/residentes/:statusType/documentacion/:casaId" element={<MiDocumentacion />} />
            <Route path="administracion/departamentos/identificacion" element={<DepartamentosIdentificacion />} />
            <Route path="administracion/departamentos/mudanzas" element={<DepartamentosMudanzas />} />
            <Route path="administracion/departamentos/rfid" element={
                <ModuloGuard moduloKey="desactivacion_rfid_morosos">
                    <DepartamentosRFID />
                </ModuloGuard>
            } />
            <Route path="administracion/departamentos/vigilancia" element={<GestionarCuentasVigilancia />} />
            <Route path="administracion/departamentos/constancia-no-adeudo" element={
                <DesktopOnlySectionGuard tituloSeccion="Constancias de No Adeudo">
                    <ConstanciaNoAdeudo />
                </DesktopOnlySectionGuard>
            } />
            <Route path="administracion/recibo-cobro" element={
                <DesktopOnlySectionGuard tituloSeccion="Emisión de Recibos de Cobro">
                    <GenerarReciboCobro />
                </DesktopOnlySectionGuard>
            } />
            <Route path="administracion/cobro-sanciones" element={
                <DesktopOnlySectionGuard tituloSeccion="Cobro de Sanciones Administrativas">
                    <CobroSanciones />
                </DesktopOnlySectionGuard>
            } />
            <Route path="administracion/cuotas-extraordinarias" element={
                <DesktopOnlySectionGuard tituloSeccion="Gestión de Cuotas Extraordinarias">
                    <CuotasExtraordinarias />
                </DesktopOnlySectionGuard>
            } />
            <Route path="administracion/consumo-agua-potable" element={
                <ModuloGuard moduloKey="consumo_agua_potable">
                    <DesktopOnlySectionGuard tituloSeccion="Control de Consumo de Agua Potable">
                        <ConsumoAguaPotable />
                    </DesktopOnlySectionGuard>
                </ModuloGuard>
            } />
            <Route path="administracion/convenios" element={
                <DesktopOnlySectionGuard tituloSeccion="Convenios de Pago">
                    <ActivarConvenios />
                </DesktopOnlySectionGuard>
            } />
            <Route path="admin/propietarios" element={<Propietarios />} />
            <Route path="admin/arrendados" element={<Arrendados />} />
            <Route path="admin/tickets" element={<GenerarTicket />} />
            <Route path="admin/crear-casa" element={<CrearCasa />} />
            <Route path="aviso-privacidad" element={<AvisoPrivacidad />} />
            <Route path="facturacion-presupuestos" element={<FacturacionPresupuestosPage />} />
        </Route>
    </Routes>
    );
};

export default SuperAdminRoutes;